import {Avatar} from '@mui/material'
import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {SIGNAL_VALUES_COLOR, signalColorsByLetter} from '../../../../constants/colors'
import {getSubjectId, WarningCircle} from '../../../../pages/biomarkers/[id]/IndicatorsAndSignals'
import {Searchify} from '../../../myTable/MyTable'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import {
    NumberTd,
    FIleOrIndex,
    INDText,
    Author,
    Text,
    Unit,
    Signal,
    AboutSignals,
    IndicatorValues,
    SignalValues,
    SignalLine,
} from './IndicatorsSignalTable.style'
import {THead} from './IndicatorsSignalTable'
import {
    EmptyTable,
    getScaleTypeColor,
} from '../../../../pages/subjects/Subject'
import {MAX_URL_LENGTH} from '../../../../pages/subjects/SubjectEdit'
import {ConnectButton} from '../../connectTo/interpretations/tableComponents'
import {Button} from "../../../customStyledElements";
import {FileWrapper, TDIdTableLInk} from '../interpretation/tableComponents'
import {patchRemove} from "../../../../redux/slice/data";
import {RemoveBtn} from "../../../listMenu/listMenu";
import {useAppDispatch} from '../../../../hooks/redux'
import {last} from 'underscore'
import getUnitType from "../../typeName";

export const Creator = ({item}: any) => {
    function getFirst(ind: number) {
        return (nameArr[ind] || {})[0] || ''
    }


    let creator = item?.creator;
    let name = creator?.name || '';
    let nameArr = name.split(' ') || [];
    let shortName = (getFirst(0) + getFirst(1)).toUpperCase()
    return <div data-td-center>
        <Avatar
            style={{height: '30px', width: '30px', marginTop: '0', float: 'left', marginRight: '5px'}}
            alt='creator'
            src={creator?.picture}
        />
        <p data-ellipse>{shortName || ''}</p>
    </div>
}
const IndicatorsSignalElem = ({
                                  data,
                                  number,
                                  linkTo,
                                  handleOpen,
                                  isSignal = false,
                                  isOpen,
                                  search,
                                  colorTypes,
                                  color,
                                  scaleArr,
                              }: any) => {
    const indexElem = number - 1
    const dispatch = useAppDispatch();

    data = data || {};
    let creator = data?.creator;
    return (
        <>
            <TDIdTableLInk to={linkTo} item={data}></TDIdTableLInk>
            <td onClick={handleOpen}>
                {/*<FileWrapper to={linkTo} top={-2} abs={true}></FileWrapper>*/}

                {/*<Link to={linkTo} data-ellipse data-title>*/}
                {/*    {item.name}*/}
                {/*</Link>*/}
                <div data-td-center>

                    <FileWrapper to={linkTo} top={5} abs={true}></FileWrapper>
                    <div className="ib" data-ellipse data-title
                         style={{ maxWidth: 'calc(100% - 65px)'}}>
                        <Searchify value={(data || {}).name || '-'} search={search}/>
                        {/*<span>{data.isWarn ? 'Warninggggg' : 'No warning'}*/}
                        {/*</span>*/}
                        {data.isWarn && <WarningCircle></WarningCircle>}
                    </div>
                    <div data-arrow-open-close>
                        <KeyboardArrowUpIcon data-hover style={{rotate: isOpen ? '0deg' : '180deg'}}/>
                    </div>
                </div>
            </td>
            <td>
                <Creator item={data}></Creator>
            </td>
            <Unit>{getUnitType(data)} </Unit>

            <td className={'scroll'}>
                <Link to={linkTo} data-notext>

                    <IndicatorValues>
                        {scaleArr
                            .map((color: any, index: number) => {
                                const signal = data.signals[index]

                                let isLast = index == scaleArr.length - 1;
                                return (
                                    <>
                                        <div
                                            key={index}
                                            style={{display: 'flex', alignItems: 'center'}}
                                        >
                                            <SignalValues
                                                key={signal?._id || index}
                                                bgcolor={color.background}
                                                color={color.color}
                                                textColor={color.textColor}
                                                borderColor={color.borderColor}
                                            >
                                                {signal?.valueFrom}
                                            </SignalValues>
                                            <SignalLine color={color.color}/>
                                        </div>
                                        {isLast && <> <SignalValues
                                            style={{width: '30px', height: '30px'}}
                                            bgcolor={color.background}
                                            color={color.color}
                                            textColor={color.textColor}
                                            iscircle={'true'}
                                        >
                                            <svg style={{width: '17px', height: '17px', position: 'absolute'}}
                                                 viewBox="0 0 14 14" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <mask id="mask0_590_2404" style={{"maskType": "alpha"}}
                                                      maskUnits="userSpaceOnUse" x="0" y="3" width="14" height="8">
                                                    <path
                                                        d="M5.82977 8.31787L5.35399 8.85381C4.98746 9.2197 4.5207 9.46873 4.01268 9.56944C3.50467 9.67014 2.9782 9.618 2.49981 9.4196C2.02142 9.2212 1.61258 8.88544 1.32494 8.45476C1.03731 8.02408 0.883789 7.5178 0.883789 6.9999C0.883789 6.482 1.03731 5.97573 1.32494 5.54505C1.61258 5.11437 2.02142 4.77861 2.49981 4.58021C2.9782 4.38181 3.50467 4.32967 4.01268 4.43037C4.5207 4.53108 4.98746 4.78011 5.35399 5.146L8.64618 8.85381C9.01271 9.2197 9.47947 9.46873 9.98748 9.56944C10.4955 9.67014 11.022 9.618 11.5004 9.4196C11.9787 9.2212 12.3876 8.88544 12.6752 8.45476C12.9629 8.02408 13.1164 7.5178 13.1164 6.9999C13.1164 6.482 12.9629 5.97573 12.6752 5.54505C12.3876 5.11437 11.9787 4.77861 11.5004 4.58021C11.022 4.38181 10.4955 4.32967 9.98748 4.43037C9.47947 4.53108 9.01271 4.78011 8.64618 5.146L8.1704 5.68194"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round"/>
                                                </mask>
                                                <g mask="url(#mask0_590_2404)">
                                                    <path d="M14 0H0V14H14V0Z" fill={color.textColor || color.color}/>
                                                </g>
                                            </svg>

                                        </SignalValues>
                                        </>}</>
                                )
                            })}
                    </IndicatorValues>
                </Link>
                <RemoveBtn
                    name={typeof data.name === 'object' 
                        ? data.name?.en || data.name?.[Object.keys(data.name || {})[0]] || ''
                        : data.name || ''}
                    top={-32} onClick={() => {
                    dispatch(patchRemove({_id: data._id, type: 'indicators'}))
                }}></RemoveBtn>
            </td>
            {/*)}*/}

        </>
    )
}

export const CreatorTD = () => {
    return <td style={{width: '150px'}}>Creator</td>
}

export const IndicatorsSignalHead = () => {
    return (
        <THead>
            <tr style={{width: '100%'}}>
                <td style={{width: '50px'}}>#</td>
                <td colSpan={1} style={{width: '45%'}}>Biomarkers</td>
                <CreatorTD></CreatorTD>
                <td style={{width: '75px'}}>Unit</td>
                <td style={{width: 'auto'}}>Value</td>
            </tr>
        </THead>
    )
}

export const Empty = () => {
    return <EmptyTable name={'biomarker'}/>
}
export const NothingFound = () => {
    return (
        <tr>
            <td colSpan={1000} className={'nothing-found'}>
                Nothing Found
            </td>
        </tr>
    )
}
const ConnectSignalButton = ({
                                 indicator,
                                 signal,
                                 signalIndex,
                                 isConnect,
                                 signalSetsByCheckboxes,
                                 onConnect,
                             }: any) => {
    // let isConnect = (connectIds || {})[item._id]
    let indicatorId = indicator?._id;
    // let isConnect = ((signalSetsByCheckboxes || {})[indicatorId] || {})[signalIndex]
    console.log("qqqqq signalSetsByCheckboxessignalSetsByCheckboxes",isConnect, signalSetsByCheckboxes, indicatorId, signalIndex);
    return (

        <button className={'btn'}
                onClick={() => onConnect(indicator, signal, signalIndex, !isConnect)}
        >
            {!isConnect ? 'Connect' : 'Disconnect'}
        </button>
    )
}
export const getIndicatorLink = (_id: any) => {
    return '/' + getSubjectId() + '/biomarkers/' + _id;
}
export const IndicatorsSignalBody = (props: any) => {
    let {search, onConnect, signalSetsByCheckboxes, connectIds} = props

    let [open, setOpen] = useState(Boolean(onConnect))
    let index = props.ind
    let indicator = props.item
    const handleViewSignal = () => setOpen(!open)
    const colorTypes = getScaleTypeColor(indicator.scaleType?.name || 'RAGAR')
    let scaleArr = getScaleTypeColor(indicator?.scaleType?.name || '')//.split('').map((letter: any) => signalColorsByLetter[letter]);
    return (<>
            <tbody key={indicator._id || index}>
            <tr style={{cursor: 'pointer'}}>
                <IndicatorsSignalElem
                    handleOpen={handleViewSignal}
                    linkTo={
                        '/' + getSubjectId() + '/biomarkers/' + indicator._id
                    }
                    scaleArr={scaleArr}
                    number={index + 1}
                    search={search}
                    isSignal={false}
                    isOpen={open}
                    data={indicator}
                    colorTypes={colorTypes}
                />
            </tr>
            </tbody>

            {open && <tbody data-animch
                            style={{'animationDelay': '0s'}}>{(scaleArr || []).map((color: any, c_index: number) => {
                let signal = (indicator.signals || [])[c_index] || {}
                let nextSignal = (indicator.signals || [])[c_index + 1] || {}
                let isOk = (signal.valueFrom || signal.valueFrom == '0');
                let connectIndicatorIds = (connectIds || {})[indicator._id] || {}
                let isConnect = c_index == (connectIndicatorIds || {}).signalIndex

                console.log("qqqqq connectIndicatorIdsconnectIndicatorIds", c_index, connectIds );

                return <tr key={c_index} data-animch style={{cursor: 'default'}}>
                    <td></td>
                    <td>
                        <div data-td-center>
                            {onConnect && <div className={'ib'} style={{marginRight: '20px'}}>
                                <ConnectSignalButton
                                    indicator={indicator}
                                    signal={indicator?.signals[c_index]}
                                    // signalSetsByCheckboxes={connectIds}
                                    signalIndex={c_index}
                                    isConnect={(connectIds[indicator?._id] || {})[c_index]}
                                    onConnect={onConnect}
                                />
                            </div>}
                            {!onConnect && <>
                                <Link to={getIndicatorLink(indicator?._id)} data-desc2 className='ib'
                                      style={{marginRight: '20px'}}>#{c_index + 1}</Link>
                            </>}
                            <div className="ib">
                                <Link to={getIndicatorLink(indicator?._id)}>{signal.name || 'No signal name'}</Link>
                            </div>
                        </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                        <div data-td-center>

                            <p data-signal-left-border style={{borderColor: color.color}}>
                                {isOk && <>
                                    {c_index == 0 ? <Infinity
                                        top={7.5}/> : signal.valueFrom} - {signal.valueTo || nextSignal.valueFrom ||
                                    <Infinity top={7.5}/>}
                                </>}
                                {!isOk && <>---</>}
                            </p>
                        </div>
                    </td>
                </tr>
            })}
            </tbody>}

        </>
    )
}

export const Infinity = (props: any) => {
    return <div style={{display: 'inline-block', width: '20px', height: '20px'}}>
        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
             style={{marginTop: (props.top || 0) + 'px', position: 'absolute', marginRight: '3px', marginLeft: '3px'}}
        >
            <mask id="mask0_195_21658" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="0" y="4" width="18"
                  height="10">
                <path
                    d="M7.49535 10.6943L6.88363 11.3834C6.41238 11.8538 5.81225 12.174 5.15909 12.3035C4.50593 12.433 3.82905 12.3659 3.21397 12.1108C2.5989 11.8558 2.07324 11.4241 1.70343 10.8703C1.33361 10.3166 1.13623 9.66568 1.13623 8.99981C1.13623 8.33394 1.33361 7.68301 1.70343 7.12928C2.07324 6.57554 2.5989 6.14386 3.21397 5.88877C3.82905 5.63369 4.50593 5.56665 5.15909 5.69612C5.81225 5.8256 6.41238 6.14578 6.88363 6.61621L11.1164 11.3834C11.5877 11.8538 12.1878 12.174 12.841 12.3035C13.4941 12.433 14.171 12.3659 14.7861 12.1108C15.4012 11.8558 15.9268 11.4241 16.2966 10.8703C16.6665 10.3166 16.8638 9.66568 16.8638 8.99981C16.8638 8.33394 16.6665 7.68301 16.2966 7.12928C15.9268 6.57554 15.4012 6.14386 14.7861 5.88877C14.171 5.63369 13.4941 5.56665 12.841 5.69612C12.1878 5.8256 11.5877 6.14578 11.1164 6.61621L10.5047 7.30528"
                    stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </mask>
            <g mask="url(#mask0_195_21658)">
                <path d="M18 0H0V18H18V0Z" fill="#1A1A1A"/>
            </g>
        </svg>
    </div>
}